import TestimonialQuoteController from "../controllers/TestimonialQuoteController";
import TestimonialVideoController from "../controllers/TestimonialVideoController";
import { VanillaPagesType } from "../core/types/VanillaPages";
import { getRandomInt } from "../core/utilities";

export default class TestimonialPanelController {
  init(type: VanillaPagesType, anchor: string, categoryName: string): boolean {
    const shouldCreate =
      ((type === VanillaPagesType.categories ||
        type === VanillaPagesType.discussions) &&
        (categoryName.includes("announcements") ||
          categoryName.includes("events"))) ||
      (type === VanillaPagesType.custompage &&
        categoryName.includes("welcome-to-cloud-customer-connect"));

    if (shouldCreate) {
      const gamble = getRandomInt(0, 6);
      console.debug("Testimonial Panel - Gamble:", gamble);
      if (gamble < 3) {
        this.startQuotePanel(anchor);
      } else {
        this.startVideoPanel(anchor);
      }

      return true;
    }

    return false;
  }

  startQuotePanel(anchor: string): void {
    const testimonialQuoteController: TestimonialQuoteController =
      new TestimonialQuoteController(anchor);

    testimonialQuoteController
      .init(VanillaPagesType.discussions)
      .catch(console.error);
  }

  startVideoPanel(anchor: string): void {
    const testimonialVideoController: TestimonialVideoController =
      new TestimonialVideoController(anchor);

    testimonialVideoController.init().catch(console.error);
  }
}
